import script from "./SelectorList.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectorList.vue?vue&type=script&setup=true&lang=js"

import "./SelectorList.vue?vue&type=style&index=0&id=090db650&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-090db650"]])

export default __exports__